import React, { useState } from "react";
import { compose } from "recompose";
import { Modal, ModalBody, ModalFooter, Table, Button } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  AddNewButton,
  withTable,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans } from "react-i18next";
import { formatDate, formatDateTime } from "services/util";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import { PendingButton } from "components/common";
import BackButton from "components/refactoring/BackButton";
import { RemoveAllButton } from "pages/Core/CoreComponents";

export const PlanList = ({
  selected,
  match,
  url = "subscription-plans",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  pending,
  search,
  onDeleted,
  refreshToken,
  readOnly,
  t,
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const toggle = () => setIsOpen(!isOpen);

  const onDelete = (id) => {
    setSelectedUserId(id);
    toggle(); 
  };

  const client = ApiClient()

  const onConfirm = async () => {
    try {
      await client.delete(`/${url}/${selectedUserId}`);
      NotificationManager.success('Subscription Plan Deleted successfully!');
      onDeleted(); 
    } catch (error) {
      console.error('Error deleting:', error);
      NotificationManager.error('An error occurred while deleting the plan.');
    } finally {
      toggle(); 
    }
  };

return (
  <Page title="Subscriptions List" className="inv-table">
    <BackButton/>
    <div className="mb-2 d-flex justify-content-center">
      <AddNewButton
        resource="Subscription Plan"
        match={match}
        className="mx-0"
        readOnly={readOnly} 
      />
      <div className="mx-auto"/>
      <RemoveAllButton className="mx-0" type="Plans" t={t}/>
    </div>
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Table style={{border: '1px solid #e9ecef'}}>
        <thead>
          <tr>
            <th className="text-left">
              <Trans>Order</Trans>
            </th>
            <th>
              <Trans>Name</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
            <th>
              <Trans>Active</Trans>
            </th>
            <th>
              <Trans>Updated at</Trans>
            </th>
            <th>
              <Trans>Monthly Price</Trans>
            </th>
            <th>
              <Trans>Yearly Price</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => (
            <tr key={i.id}>
              <td className="text-left">{i.order}</td>
              <td>{i.name}</td>
              <td>{i.status}</td>
              <td>
              {i.active ? (
                    <span className="fa fa-check-circle text-success" />
                  ) : (
                    <span className="fa fa-times-circle text-danger" />
                  )}
              </td>
              <td>{formatDate(i.updated_at)}</td>
              <td>{i.monthly_price?.price} <span className="text-muted">{i.monthly_price?.currency}</span></td>
              <td>{i.yearly_price?.price} <span className="text-muted">{i.yearly_price?.currency}</span></td>
              <td className="text-end edit-btn">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={() => onDelete(i.id)}
                  readOnly={readOnly}
                />
              </td>
             
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <Trans>
            Are you sure you want to delete this user?
          </Trans>
        </ModalBody>
        <ModalFooter>
          <PendingButton color="primary" pending={pending} onClick={onConfirm}>
            Confirm
          </PendingButton>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
  </Page>
)};

const enhance = compose(withTable({ limit: 999999 }));

export default enhance(PlanList)